// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__mwTU1","question":"Question_question__1uHE7","description":"Question_description__3uhKd"};